import { get, isEmpty } from 'lodash';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();
export default {
  /* This API takes the following params:
    {
      type,
      fields: [
        {
          type,
          label,
          placeholder,        // required if type is 'dropdown' or 'string'
          options: {
            displayValue,
          },                  // required if type is 'dropdown'
          uniqueAcross,       // required if type is 'string'
        displayValue,         // required if type is 'checkbox'
        },
      ],      
    }
  */
  async updateCustomField(params) {
    try {
      await checkLicenseExpiry();
      const { data: customField } = await req.post('customFields', params);
      return customField;
    } catch (e) {
      throw e;
    }
  },
  /*
    This API takes the following params:
    {
      type, // type of the screen/tab
    }
  */
  async getCustomFields(params = {}) {
    try {
      const type = params.type || '';
      const initialLoad = get(params, 'initialLoad', false);
      await checkLicenseExpiry();
      const { data: customFields } = await req.get(`customFields/${type}`, { params: { initialLoad } });
      return customFields;
    } catch (e) {
      throw e;
    }
  },
  /* 
    This API takes the following params:
    {
      companyId,      // '_id' of user's company
      type,           // type of the custom fields template
      fieldId,        // '_id' of the fields inside custom fields template
      fieldValue,     // 'value' of the fields inside custom fields template
      cardId,         // '_id' of card or order
      projectId,      // '_id' of project 
    }
  */
  async checkUniqueValue(params) {
    try {
      const { data } = await req.post('customFields/checkUniqueValue', params );
      return data;
    } catch (e) {
      throw e;
    }
  },
  /* 
    This API takes the following params:
    {
      fieldValue,    // 'value' of the fields inside custom fields template
      fieldType.     // '__t' of the fields inside custom fields template
    } 
  */
  async validateFields(params) {
    try {
      const { data } = await req.post('customFields/validateFields', params );
      return data;
    } catch (e) {
      throw e;
    }
  },
  /* 
    This API takes the following params:
    {
      type,           // type of the activity,
      page,           // page number for pagination,
      limit,          // number of records per page,
    }
  */
  async getCustomFieldActivity(params = {}) {
    try {
      const apiParams = { limit: params.limit, page: params.page }
      if (!isEmpty(params.search)) apiParams.search = params.search
      const { data } = await req.get(`customFields/activities/${params.type}`, { params:  apiParams});
      return data;
    } catch (e) {
      throw e;
    }
  },
};